export const constants = {
    HOME_ANALYTIC_EVENT: "home_event",
    ABOUT_ANALYTIC_EVENT: "about_event",
    PROJECTS_ANALYTIC_EVENT: "projects_event",
    ARTWORK_ANALYTIC_EVENT: "artwork_event",
    PHOTOGRAPHY_ANALYTIC_EVENT: "photography_event",
    BLOG_ANALYTIC_EVENT: "blog_event",
    OTHER_ANALYTIC_EVENT: "other_event",
    CONTACT_ANALYTIC_EVENT: "contact_event",
};